export const BASE_URL = "https://lucid-hodgkin-40d25e.netlify.app";


const getImageURL = (imgPath) => {
  return `${BASE_URL}${imgPath}`
}

export default [
  {
    title: "البحر المحيط",
    coords: "31,113,138,207",
    shape: "rect",
    images: [
      getImageURL(`/documents/room-moheet/1.png`)
    ]
  },
  {
    title: "المغرب",
    coords: "385,277,250,228",
    shape: "rect",
    images: [
      getImageURL(`/documents/maghreb/1.png`),
      getImageURL(`/documents/maghreb/2.png`)
    ]
  },
  {
    title: "بحر الروم",
    coords: "605,232,475,184",
    shape: "rect",
    images: [getImageURL(`/documents/room-moheet/1.png`)]
  },
  {
    title: "مصر",
    coords: "631,287,705,330",
    shape: "rect",
    images: [
      getImageURL(`/documents/masr/1.png`),
      getImageURL(`/documents/masr/2.png`)
    ]
  },
  {
    title: "الشام",
    coords: "778,204,852,235",
    shape: "rect",
    images: [
      getImageURL(`/documents/sham/1.png`),
      getImageURL(`/documents/sham/2.png`)
    ]
  },
  {
    title: "الجزيرة",
    coords: "867,336,976,378",
    shape: "rect",
    images: [
      getImageURL(`/documents/jazeera/1.png`),
      getImageURL(`/documents/jazeera/2.png`),
      getImageURL(`/documents/jazeera/3.png`)
    ]
  },
  {
    title: "بحر الصين",
    coords: "1042,526,1271,592",
    shape: "rect",
    images: [getImageURL(`/documents/seen-qalzam/1.png`)]
  },
  {
    title: "السند",
    coords: "1244,316,1326,347",
    shape: "rect",
    images: [
      getImageURL(`/documents/send/1.png`),
      getImageURL(`/documents/send/2.png`)
    ]
  },
  {
    title: "المشرق",
    coords: "1196,127,1335,187",
    shape: "rect",
    images: [
      getImageURL(`/documents/mashreq/1.png`),
      getImageURL(`/documents/mashreq/2.png`),
      getImageURL(`/documents/mashreq/3.png`),
      getImageURL(`/documents/mashreq/4.png`),
      getImageURL(`/documents/mashreq/5.png`)
    ]
  },
  {
    title: "العراق",
    coords: "877,235,957,276",
    shape: "rect",
    images: [
      getImageURL(`/documents/iraq/1.png`),
      getImageURL(`/documents/iraq/2.png`)
    ]
  },
  {
    title: "أقور",
    coords: "860,176,920,212",
    shape: "rect",
    images: [
      getImageURL(`/documents/aghour/1.png`),
      getImageURL(`/documents/aghour/2.png`)
    ]
  },
  {
    title: "الرّحاب",
    coords: "975,146,892,105",
    shape: "rect",
    images: [
      getImageURL(`/documents/rehab/1.png`),
      getImageURL(`/documents/rehab/2.png`)
    ]
  },
  {
    title: "الديلم",
    coords: "1043,122,1123,156",
    shape: "rect",
    images: [getImageURL(`/documents/deelm/1.png`)]
  },
  {
    title: "كرمان",
    coords: "1115,283,1193,317",
    shape: "rect",
    images: [
      getImageURL(`/documents/qarman/1.png`),
      getImageURL(`/documents/qarman/2.png`)
    ]
  },
  {
    title: "الجبال",
    coords: "999,177,1074,216",
    shape: "rect",
    images: [
      getImageURL(`/documents/aljebal/1.png`),
      getImageURL(`/documents/aljebal/2.png`)
    ]
  },
  {
    title: "الخوز",
    coords: "968,230,1040,263",
    shape: "rect",
    images: [
      getImageURL(`/documents/khouz/1.png`),
      getImageURL(`/documents/khouz/2.png`)
    ]
  },
  {
    title: "فارس",
    coords: "1092,262,1016,290",
    shape: "rect",
    images: [
      getImageURL(`/documents/fares/1.png`),
      getImageURL(`/documents/fares/2.png`)
    ]
  },
  {
    title: "القلزم",
    coords: "828,364,793,390,841,465,888,443",
    shape: "poly",
    images: [getImageURL(`/documents/seen-qalzam/1.png`)]
  }
];
